import React, { useState, useEffect } from 'react';
import './home.css';
import face from '../../image/profile-picture.png';
import useScrollReveal from '../../hooks/useScrollReveal';

function Home() {
    const titles = [
        'UI/UX Designer',
        'Bug Bounty Hunter',
        'Web Developer',
        'Cybersecurity Student'
    ];

    const [titleIndex, setTitleIndex] = useState(0);
    const [displayText, setDisplayText] = useState('');
    const [isDeleting, setIsDeleting] = useState(false);
    const sectionRef = useScrollReveal();

    useEffect(() => {
        let timeout;
        const fullText = titles[titleIndex];

        if (!isDeleting && displayText === fullText) {
            timeout = setTimeout(() => setIsDeleting(true), 1000);
        } else if (isDeleting && displayText === '') {
            timeout = setTimeout(() => {
                setIsDeleting(false);
                setTitleIndex((titleIndex + 1) % titles.length);
            }, 300);
        } else {
            const delta = isDeleting ? 60 : 120;
            timeout = setTimeout(() => {
                const next = isDeleting
                    ? fullText.substring(0, displayText.length - 1)
                    : fullText.substring(0, displayText.length + 1);
                setDisplayText(next);
            }, delta);
        }

        return () => clearTimeout(timeout);
    }, [displayText, isDeleting, titleIndex]);

    return (
        <div className="Home-hero" id="Home" ref={sectionRef}>
            <div className="Home-content">
                <div className="Home-left-side">
                    <div className="intro scroll-reveal">
                        <p className="greeting-tag">&lt;Hello World /&gt;</p>
                        <h1 className="greeting">Hi There,</h1>
                        <h1 className="name">
                            I'm <span className="name-highlight">Dehili Mohammed</span>
                        </h1>
                        <p className="lead">
                            I Am a{' '}
                            <span className="rotating-title" aria-live="polite">
                                {displayText}
                            </span>
                            <span className="cursor-blink">|</span>
                        </p>
                        <p className="hero-description">
                            Passionate about building secure, modern web applications and
                            uncovering vulnerabilities through ethical hacking. Currently
                            pursuing a cybersecurity degree while sharpening my full-stack
                            development skills.
                        </p>
                    </div>
                    <div className="Home-credentails scroll-reveal delay-2">
                        <button className="btn-primary">
                            <a href="#About">
                                <i className="fas fa-user"></i> About Me
                            </a>
                        </button>
                        <button className="btn-outline">
                            <a href="#contact">
                                <i className="fas fa-paper-plane"></i> Get in Touch
                            </a>
                        </button>
                    </div>
                    <div className="Home-icon scroll-reveal delay-3">
                        <a href="https://www.linkedin.com/in/dehili-mohammed-0664092b4/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                            <i className="fab fa-linkedin-in"></i>
                        </a>
                        <a href="https://github.com/Dehili-Mohammed" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
                            <i className="fab fa-github"></i>
                        </a>
                        
                        <a href="https://www.instagram.com/dm._.mohe_med/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                            <i className="fab fa-instagram"></i>
                        </a>
                        <a href="https://dev.to/dm_mohammed" target="_blank" rel="noopener noreferrer" aria-label="Dev.to">
                            <i className="fab fa-dev"></i>
                        </a>
                    </div>
                </div>
                <div className="Home-right-side scroll-reveal from-right delay-1">
                    <div className="profile-image-wrapper">
                        <img src={face} alt="Dehili Mohammed" className="Home-profile-image" />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;